// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@synd/XDL/types";

import accordion from "@synd/XDL/PreStyle/accordion";
import breadcrumbs from "@synd/XDL/PreStyle/breadcrumbs";
import breakpoints from "@synd/XDL/PreStyle/breakpoints";
import button from "@synd/XDL/PreStyle/button";
import checkbox from "@synd/XDL/PreStyle/checkbox";
import colors from "@synd/XDL/PreStyle/colors";
import dataTable from "@synd/XDL/PreStyle/dataTable";
import datePicker from "@synd/XDL/PreStyle/datePicker";
import drawer from "@synd/XDL/PreStyle/drawer";
import dynamicDropdown from "@synd/XDL/PreStyle/dynamicDropdown";
import focus from "@synd/XDL/PreStyle/focus";
import footer from "@synd/XDL/PreStyle/footer";
import formField from "@synd/XDL/PreStyle/formField";
import globalStyle from "@synd/XDL/PreStyle/globalStyle";
import header from "@synd/XDL/PreStyle/header";
import icon from "@synd/XDL/PreStyle/icon";
import link from "@synd/XDL/PreStyle/link";
import lists from "@synd/XDL/PreStyle/lists";
import loadingOverlay from "@synd/XDL/PreStyle/loadingOverlay";
import menu from "@synd/XDL/PreStyle/menu";
import modal from "@synd/XDL/PreStyle/modal";
import overflowMenu from "@synd/XDL/PreStyle/overflowMenu";
import pagination from "@synd/XDL/PreStyle/pagination";
import panelMenu from "@synd/XDL/PreStyle/panelMenu";
import radio from "@synd/XDL/PreStyle/radio";
import select from "@synd/XDL/PreStyle/select";
import shadows from "@synd/XDL/PreStyle/shadows";
import swatch from "@synd/XDL/PreStyle/swatch";
import tab from "@synd/XDL/PreStyle/tab";
import tag from "@synd/XDL/PreStyle/tag";
import textArea from "@synd/XDL/PreStyle/textArea";
import toast from "@synd/XDL/PreStyle/toast";
import tooltip from "@synd/XDL/PreStyle/tooltip";
import typography from "@synd/XDL/PreStyle/typography";
import zIndex from "@synd/XDL/PreStyle/zIndex";

export default {
    breakpoints,
    colors,
    focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    header,
    formField,
    // fieldSet,
    icon,
    // layoutTable,
    // layoutGroup,
    // layoutCell,
    link,
    lists,
    // lazyImage,
    loadingOverlay,
    // loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    swatch,
    tab,
    tag,
    // tagsField,
    // textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
    footer,
} as xBaseTheme;
